import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"

export const ActionButtons = ({ form, onCancel, onSave, onSaveAndAddNew, onDelete }) => {
  const [t] = useTranslation()

  return (
    <Flex justify="space-between" className="mt-xl">
      <Flex gap={spacings.S}>
        <Button color="primary" variant="outlined" size="large" onClick={onCancel}>
          {t("global.cancel")}
        </Button>
        <Button color="primary" variant="solid" size="large" onClick={onSave}>
          {t("global.save")}
        </Button>
        <Button color="primary" variant="solid" size="large" onClick={onSaveAndAddNew}>
          {t("global.save_add_new")}
        </Button>
      </Flex>
      <Button color="danger" variant="solid" size="large" onClick={onDelete}>
        {t("global.delete")}
      </Button>
    </Flex>
  )
}
